import { deleteDismissedData } from "./dismiss";
import { deleteRedirectData } from "./redirect";
import { deleteBounceData } from "./bounce";
import { deleteRecoveryData, getRecoveryData } from "./recovery";
import {
  deleteAttributionExpiry,
  getAttributionExpiry,
} from "./attributionExpiry";
import { deleteSingleClickFlag } from "./singleClick";
import { deleteRenderData, getLastRenderDate } from "./render";
import { clearAllInteractionsCount } from "./renderCount";
import { UserLocalStorageState } from "../types";
import { log, shouldLogByProbability } from "../utils/logs";

export async function invalidateUserData(invalidateCounters = true) {
  await Promise.all([
    deleteRenderData(),
    deleteDismissedData(),
    deleteAttributionExpiry(),
    deleteRecoveryData(),
    invalidateCounters ? clearAllInteractionsCount() : Promise.resolve(),
  ]).catch((error) => {
    if (shouldLogByProbability()) {
      log(
        "rlink.invalidateUserDataError",
        {
          aaResults: window.__bt_intrnl.aaDetectionResults,
          consentData: window.__bt_intrnl.consentData,
          error: error instanceof Error ? error.message : error,
        },
        { severity: 4 },
      );
    }
  });
  deleteRedirectData();
  deleteBounceData();
  deleteSingleClickFlag();
}

export async function getUserState(): Promise<
  UserLocalStorageState | undefined
> {
  const [renderDate, attributionExpiry, recoveryType] = await Promise.all([
    getLastRenderDate(),
    getAttributionExpiry(),
    getRecoveryData(),
  ]);
  if (!renderDate && !recoveryType && !attributionExpiry) {
    // no data found in local storage
    return undefined;
  }
  return {
    recoveryType,
    renderDate,
    attributionExpiry,
  } as UserLocalStorageState;
}
